import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';

var useId = function useId(idOverride, type) {
  var _useState = useState(idOverride),
    _useState2 = _slicedToArray(_useState, 2),
    defaultId = _useState2[0],
    setDefaultId = _useState2[1];
  var id = idOverride || defaultId;
  useEffect(function () {
    if (defaultId == null) {
      setDefaultId("eds-".concat(type ? type + "-" : '').concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId, type]);
  return id;
};

export { useId };
